module.exports = __webpack_public_path__ + "img/margot-minuscules.5f88e344.jpg";